import SectionWhoIsItFor from './SectionWhoIsItFor';
export default SectionWhoIsItFor;
